// =========================================================
// The release this bundle was built from
// =========================================================
//
// `NEXT_PUBLIC_APP_RELEASE` is set in the build stage from the same
// build-arg the container turns into `APP_RELEASE`, so this value and
// the release the serving container reports are the same string by
// construction.
//
// The reference below is written out in full on purpose. Next replaces a
// statically referenced `process.env.NEXT_PUBLIC_*` with its value while
// building, which is exactly what is wanted here: the release has to
// travel inside the bundle, not be read from the environment of whatever
// pod happens to serve it. Elsewhere in this app the same expression is
// deliberately hidden behind an alias so it stays a runtime lookup —
// those values belong to the pod, this one belongs to the build.
//
// Exposed as a function so tests can mock a single module boundary
// instead of manipulating `process.env`, which the production image build
// sets and local runs do not.
//
// Development builds have no build-arg and therefore no release. An empty
// value means "I do not know what I am running", which every caller
// treats as a reason not to act rather than a reason to guess.
export function getOwnRelease(): string {
  return process.env.NEXT_PUBLIC_APP_RELEASE ?? '';
}
